import { lazy } from 'react';

export const ConfirmPayment = lazy(() => import('./ConfirmPayment.component'));
